var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnsureQuality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m356.1 393.7c-43.4 23.4-131.3 70.8-174.9 94.3 0-48.6 0-146.4 0-194.9 45.1-24.3 135.8-73.2 180.8-97.5v97.4 90.7c0 4.3-2.2 8-5.9 10z",
    fill: "#fcbd34",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m6.3 393.7c43.4 23.4 131.3 70.8 174.9 94.3 0-48.6 0-146.4 0-194.9-45.1-24.3-135.8-73.2-180.8-97.5v97.4 90.7c0 4.3 2.1 8 5.9 10z",
    fill: "#fccb30",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m122.6 261.4c-15.8-8.5-47.7-25.7-63.6-34.3v57.9c7.1 3.8 55.3 29.8 63.6 34.3z",
    fill: "#f9f8f4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m362 195.6c-45.1 24.3-135.8 73.2-180.8 97.5-45.1-24.3-135.8-73.2-180.8-97.5l90.4-48.7 85.1-45.9c3.4-1.9 7.3-1.9 10.7 0 43.5 23.5 131.7 71 175.4 94.6z",
    fill: "#fccb30",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m122.5 261.4c-15.8-8.5-47.6-25.7-63.4-34.2l180.8-97.5c15.8 8.5 47.6 25.7 63.4 34.2z",
    fill: "#f9f8f4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m313 165.5 59.3 34.2-57.8 100.1c-3.7-10.7-11.1-32.2-14.8-42.9-11.1 2.2-33.4 6.5-44.5 8.6z",
    fill: "#ff8048",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m453.9 165.5-59.3 34.2 57.8 100.1c3.7-10.7 11.1-32.2 14.8-42.9 11.1 2.2 33.4 6.5 44.5 8.6z",
    fill: "#ff8048",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m383.4 24c11.3 0 19.6 17.8 29.8 21.2s27.1-6.1 35.5.2c8.5 6.2 4.5 25.1 10.7 33.6s25.5 10.5 28.9 20.7-10.7 23.6-10.7 34.9 14.1 24.8 10.7 34.9c-3.4 10.2-22.7 12.2-28.9 20.7s-2.2 27.4-10.7 33.6-25.4-3.2-35.5.2c-10.2 3.4-18.5 21.2-29.8 21.2s-19.6-17.8-29.8-21.2-27.1 6.1-35.5-.2c-8.5-6.2-4.5-25.1-10.7-33.6s-25.5-10.5-28.9-20.7 10.7-23.6 10.7-34.9-14.1-24.8-10.7-34.9c3.4-10.2 22.7-12.2 28.9-20.7s2.2-27.4 10.7-33.6 25.4 3.2 35.5-.2c10.2-3.4 18.5-21.2 29.8-21.2z",
    fill: "#00beae",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m325 139.7c-14.3-14.8 7.4-36.6 22.2-22.2 0 0 27.1 27.1 27.1 27.1l45.4-45.4c14.8-14.3 36.6 7.4 22.2 22.2 0 0-56.5 56.5-56.5 56.5-6.1 6.1-16.1 6.1-22.2 0z",
    fill: "#f9f8f4",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnsureQuality);
export default __webpack_public_path__ + "static/media/ensure-quality.4fa0efac7b33fb661b376845da5fead5.svg";
export { ForwardRef as ReactComponent };